import { dataCopy } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCopy = /*#__PURE__*/createIcon(dataCopy)
export default IconCopy
